import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = ({ variant = "default" }) => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith("ar") ? "ar" : "en";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const toggle = () => {
    const next = lang === "ar" ? "en" : "ar";
    i18n.changeLanguage(next);
    localStorage.setItem("rtc_lang", next);
  };

  if (variant === "minimal") {
    return (
      <button
        onClick={toggle}
        className="font-mono-rtc text-[11px] uppercase tracking-[0.2em] text-current hover:text-[#FF5A00] transition-colors"
        data-testid="lang-switcher"
        aria-label="Switch language"
      >
        {lang === "ar" ? "EN" : "ع"}
      </button>
    );
  }

  return (
    <button
      onClick={toggle}
      className="inline-flex items-center gap-1 px-3 py-1 border-2 border-current font-mono-rtc text-[11px] uppercase tracking-[0.2em] hover:bg-[#FF5A00] hover:text-white hover:border-[#FF5A00] transition-colors"
      data-testid="lang-switcher"
      aria-label="Switch language"
    >
      {lang === "ar" ? "EN" : "ع AR"}
    </button>
  );
};

export default LanguageSwitcher;
